import API from "@/api/lib/api";

export const getAllPizzas = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/pizzas`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSinglePizza = async (item_id) => {
  try {
    const response = await API.get(`restaurant/pizzas/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const createPizza = async (data) => {
  try {
    const response = await API.post(`restaurant/pizzas`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};



export const updatePizza = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/pizzas/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const deletePizza = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/pizzas/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};